import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import SearchWithQuery from "../../../UI/SearchWithQuery/SearchWithQuery";
import Checkbox from "../../../../../components/shared/checkbox";
import MessageService from "../../../../Services/Message.service";
import useService from "../../../Hooks/useService";
import useParams from "../../../Hooks/useParams";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import MessageListItem from "../MessageListItem";
import { AlertError } from "../../../UI/StandardAlerts/StandardAlerts";
import Loading from "../../../UI/Loading/Loading";
import { getMessageInboxNewPath } from "../../../Pages/Message/MessageRoutes/MessageRoutes";
import SecondarySidebarFullWidthOnMobileLayout from "../../../Layout/SecondarySidebarFullWidthOnMobileLayout";
const MAX_MESSAGES = 10;
const MessageInboxSecondarySidebar = (props) => {
    // Use Params to get the search query for the inbox list
    const params = useParams();
    const searchQuery = params.searchQuery;
    const [messagesState, loadMessages, messagesStateActions] = useService(MessageService.getAdvisorInbox);
    const [loadNextPageState, loadNextPageInternal] = useService(MessageService.getAdvisorInbox);
    /**
     * Making sure we allow the user to switch to fullscreen
     * */
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMobileFullScreen, setIsMobileFullScreen] = useState(false);
    /**
     * "UNREAD" checkbox state
     * */
    const [isUnread, setIsUnread] = useState(false);
    /**
     * Creating ref for the Page Number
     * */
    const pageNumber = useRef(0);
    const loadNextPage = () => {
        pageNumber.current += 1;
        loadNextPageInternal({
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string | undefined'.
            max: MAX_MESSAGES,
            offset: pageNumber.current * MAX_MESSAGES,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
            query: searchQuery,
            unread: isUnread,
        }).then((response) => {
            var _a;
            messagesStateActions.edit(Object.assign(Object.assign({}, response), { data: (((_a = messagesState.data) === null || _a === void 0 ? void 0 : _a.data) || []).concat(response.data) }));
        });
    };
    /**
     * Any time user searches anything or the unread checkbox is changed,
     * we will load the messages and initialize page to 0
     * */
    useEffect(() => {
        pageNumber.current = 0;
        loadMessages({
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'string | undefined'.
            max: MAX_MESSAGES,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
            query: searchQuery,
            unread: isUnread,
        });
    }, [loadMessages, searchQuery, isUnread]);
    // @ts-expect-error - TS7006 - Parameter 'messages' implicitly has an 'any' type.
    const renderLoadMoreButton = (messages) => {
        var _a, _b;
        const hasPages = !!(((_b = (_a = messagesState.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) &&
            messagesState.data.data.length < messagesState.data.total);
        if (messages.data.length > 0 && hasPages) {
            return (_jsxs("button", { className: "list-group-item list-group-item-action bg-light text-center clickable", onClick: loadNextPage, title: "Load more", disabled: loadNextPageState.isLoading, children: ["Load more", loadNextPageState.isLoading && _jsx(Loading, { className: "ml-2" })] }));
        }
        return null;
    };
    const onUnreadChange = (event) => {
        setIsUnread(event.target.checked);
    };
    return (
    // @ts-expect-error - TS2786 - 'SecondarySidebarFullWidthOnMobileLayout' cannot be used as a JSX component.
    _jsx(SecondarySidebarFullWidthOnMobileLayout, { contentFullScreen: isFullScreen, contentMobileFullScreen: isMobileFullScreen, sidebar: _jsx(SecondaryNavLayout, { nav: _jsxs("div", { className: "d-flex w-100 align-items-center justify-content-between", children: [_jsxs("span", { children: [(messagesState.data && messagesState.data.total) || 0, " ", "Conversations"] }), _jsx("span", { children: _jsxs(Link, { className: "btn btn-link", title: "Create a new message", to: getMessageInboxNewPath(), children: [_jsx(FAIcon, { icon: "plus", addMarginRight: true }), "New", _jsx("span", { className: "sr-only", children: "Create a new message" })] }) })] }), children: _jsx("div", { className: "custom-scrollbar fullHeightMinusSecondaryNav touch-scroll", style: { overflowY: "auto" }, children: _jsxs("div", { className: "list-group list-group-flush border-bottom", children: [_jsxs("div", { className: "list-group-item border-top-0 py-2 px-1 d-flex align-items-end flex-column bg-light", children: [_jsx(SearchWithQuery
                                // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
                                , { 
                                    // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
                                    value: searchQuery, paramLabel: "searchQuery", title: "Search by ID or Name...", ariaLabel: "Search", placeholder: "Search by ID or Name...", type: "search" }), _jsx(Checkbox, { label: "Unread", checked: isUnread, className: "mt-2", onChange: onUnreadChange })] }), _jsx(ServiceResult, { state: messagesState, children: (messages) => (_jsxs(_Fragment, { children: [messages.data.map((message) => (_jsx(MessageListItem, { message: message, hasPermissionForTermSuccessScore: props.hasPermissionForTermSuccessScore, hasPermissionForCourseSuccessScore: props.hasPermissionForCourseSuccessScore }, message.threadId))), loadNextPageState.hasError && (_jsx(AlertError, { className: "mb-0", message: "There was an error loading more messages" })), renderLoadMoreButton(messages)] })) })] }) }) }), large: true, children: props.children(isFullScreen, setIsFullScreen, setIsMobileFullScreen) }));
};
export default MessageInboxSecondarySidebar;
